var objArchSettings = {
    // <summary>
    // This object holds all settings and options of the vcMenuTemplate
    // </summary>

    _setVariables: function (me) {
        me.userOptions = new window.vcUserOptions(); // user options - rampmenu
        me.userOptionsSL = new window.vcUserOptions(); // user options - rampsignallist
        //me.vcMenu1 = { obj1: null };
        me.vcMenu = { obj: null }; //contains the complete html structure as objects
        me.date = null;
        me.signals = null; //signal container
        me.treeMenu = null; //menu container
        me.details = null; // signal details container
        me.tempCharts = [];
        me.currentTempChart = null;
        me.exportPopup = null;
        me.selTagBsaids = [];

        me.ready = false; // add new status variable to check, if HTML is already initialized - some functions are only called, if initialization is finished
        me.firstDCFetchDone = false; // checks if fetchDC was already made once or not

        me.chartClick = {
            popup: null,
            content: null,
            chart: null,
            reloadNecessary: false,
            type: null,
            menu: { active: false, bsaid: 0, date: null, x: 0, y: 0, w: 0, h: 0 }
        }

        me.globalVisualListKey = "-";
        me.history = { list: [], current: -1, dirty: false };
        me.currentHistory = -1;
        me.minWidthforTopMenu = 1600,
            me.optionBoxWidth = 320,
            me.minWidthforMainRightWrapper = 650,
            me.mousePos = { x: 0, y: 0 },

            me.data = {
                zstTypes: null,
                hwMeter: null,
                hwMeterFormat: null,
                hwMeterType: null
            };
        me.status = {
            //conains all current menu settings - gets updated after each menu change
            date: {
                interval: 1,
                isSingle: true,
                singleDate: null,
                dateRange: { from: null, to: null },
                dateRangeComparison: { from: null, to: null },
                flexibleInterval: -1,
                dateComparisonType: -1 // 0: flex, 1: fix, 2: last year
            },
            menu: {
                interval: 1,//if high, we will show all signals
                datatype: 1,
                startDate: null,
                endDate: null,
                usePrice: false, useCo2: false, accumulated: false, addTemp: false, activateDataCenter: false, singleValueAsConsumption: false, fill0: true, showDetails: false,
                selectedChart: "",
                chartType: "spline"
            },

            dirty: {
                reload: false,
                signals: false,
                dtreeMenu: false,
                plausList: false,
                status: false,
                details: false,
                openTickets: null
            },
            signals: {
                allSelectedBsaids: [],
                selectedBsaids: [],
                allSelectedMeta: [],
                selectedMeta: [],
                hiddenSeries: [],
                temperatureBsaid: -1,
                shareParameter: null,
                selectionLimit: 500
            },
            dcFilters: { // ds filters integrated in the signal selection area
                allProblematicSignals: null,
                allSignalPlausibilities: null,
                validityTypes: {  // holds all lists of filtered signals regarding the validity (invalid, unplausible, missing)                   
                    allInvalidSignals: [], // id 0
                    allUnplausibleSignals: [], // id 1
                    allMissingSignals: [] // id 2
                },
                signalTypes: { // holds all lists of filtered signals regarding signal type (rule, measure)
                    allOnlyMeasures: [], // id 0 -> index of buttons
                    allOnlyRules: [] // id 1                                      
                },
                additionalTypes: { // holds all lists of filtered signals regarding additional attributes (public, internal, etc)
                    allInactiveSignals: [], // id 0
                    allActiveSignals: [], // id 1
                    allSummables: [], // id 2
                    allNotSummables: [], // id 3
                    allPublics: [], // id 4
                    allInternals: [], // id 5
                    allDelayed: [], // id 6
                    allOnTime: [], // id 7
                    allImported: [], // id 8
                    allNotImported: [] // id 9                       
                },
                plausTypes: {
                    noPlaus: [], // id 0
                    allStandard: [], // id 1
                    allShutdowns: [], // id 2
                    allDisturbances: [], // id 3
                    allOutliers: [], // id 4
                    allConstantControls: [] // id 5
                },
                autoCheckTypes: {
                    allACSignals: [], // id  0
                    allONSignals: [], // id 1
                    allOKSignals: [], // id 2
                    allNASignals: [], // id 3
                    allEditSignals: [] // id 4                    
                },
                filterLists: { // holds info regarding the currently selected filters (filter buttons active)
                    activeValFilters: [], // holds all currently selected validity filters (id of filter)
                    valFilteredSignals: [], // holds a list of all selected invalid signals
                    activeTypeFilters: [], // holds all currently selected type filters (id of filter)
                    typeFilteredSignals: [],  // holds a list of all selected type signals     
                    activeAddFilters: [], // holds all currently selected additional filters (id of filter)
                    addFilteredSignals: [], // holds a list of all additional type filters (e.g. public)
                    activePlausFilters: [],
                    plausFilteredSignals: [],
                    activeAutoCheckFilters: [],
                    autoCheckFilteredSignals: []
                },
                fileImportList: [78, 31, 58, 54, 74]

            },
            signalDetails: {
                show: false,
                Object: null
            },
            subvisual: {
                selectedBsaid: -1,
                wrapper: {
                    width: 0,
                    height: 0
                },
                content: {
                    width: 0,
                    height: 0
                }

            },

            treeMenuId: 0,
            treeMenuStatus: [],
            menuFilter: "",
            firstChoiceFilled: false,
            dataLoaded: false,
            widthEntries: 0,
            heightContent: 0,
            madeSelection: false,
            showContent: true,
            popupIdentifier: 0,
            userOptions: null, // user options with optgroupid = rampmenu
            userOptionsSL: null, // user options with optgroupid = rampsignallist
            choiceListType: 0, //0 = signals, 1 = meta
            toggleOptionBoxVisibility: false // if true, visibility of option box is depending on showContent (if content is shown, option box is visible, otherwise not)
        };

        me.settings = $.extend({}, me.settings, {
            //if we toggle our view - we have to add a selection button and switch between selection and content (we start with content)
            toggleView: true,
            signalSelection: true, //we can select/unselect signals (eg. archive)
            showAllSignalsAtStart: false,
            enableFilterForInvalidSignals: true,
            hideSignalsWithNotAllowedSettings: false,
            defaultChart: "archive",
            showArchiveRules: true,
            charts: null,  //list of additional chart icons in the top menu is added separately

            currentIconChart: { active: false, iconChart: null, parameter: null, signalparameter: null }, // holds the current loaded icon chart (one of the iconCharts object)

            enableMeta: false,
            mobile: false,
            menu: {
                top: {
                    showMenuAsDropdown: false, // show top menu as dropdown list (e.g. in archive)
                    showHeaders: true,
                    interval: {
                        enabled: true,
                        cols: 2,
                        intervals: [1, 3, 5],
                        default: 1 //default interval
                    },
                    datatype: {
                        enabled: true,
                        cols: -1,
                        showAccumulated: true,
                        showSingleValueAsConsumption: true,
                        showFill0: true,
                        showAddTemp: true,
                        showPrice: true,
                        showCo2: true,
                        showDetails: true,
                        showDataCenter: true,
                        showHr: true
                    },
                    charts: {
                        enabled: true,
                        cols: -1

                    },
                    opt: {
                        enabled: true,
                        cols: -1,
                        showRules: true,
                        showTags: true,
                        showInterventions: true,
                        showTickets: true
                    },
                    export: {
                        enabled: true,
                        cols: -1,
                        width: 615,
                        showFavorites: true,
                        showShare: true,
                        warnExternalExport: true
                    }
                },
                main: {
                    button: {
                        enabled: true,
                        cols: 2,
                        showTakeBtnOnly: false,
                        takeButtonBroadcastsContent: false,
                        selection: {
                            enabled: true
                        },
                        reload: {
                            enabled: true,
                            broadcastStatus: false
                        }

                    },
                    date: {
                        enabled: true,
                        showTimespan: true,
                        cols: 2
                    },
                    dateComparison: {
                        enabled: true,
                        cols: 2
                    },
                    rampResolution: {
                        enabled: true,
                        cols: 2
                    },

                    rampOptions: {
                        enabled: true,
                        cols: 2
                    },
                    rampTempCharts: {
                        enabled: false,
                        cols: 2
                    },

                    specificOptions: {
                        enabled: false,
                        cols: 2
                    },
                    history: {
                        enabled: true,
                        cols: -1
                    }
                }
            },

            selection: {
                choice: {
                    enabled: true,
                    cols: 2
                },
                treemenu: {
                    enabled: true,
                    cols: 2

                },
                entries: {
                    enabled: true,
                    cols: 0,
                    cssClass: "ramp-signal-list",

                    filter: {
                        enabled: true,
                        cols: 4,
                        vcFilterCols: 2
                    },
                    button: {
                        enabled: true,
                        cols: 1
                    },
                    signals: {
                        enabled: true,
                        cols: 0,
                        showIcons: true,
                        cssClassTagsCol: "col2",
                        cssClassHwCol: "col3",
                        charts: {
                            showDataFlow: true,
                            showMeterReadings: true
                        }
                    }
                }
            },
            subvisual: {
                content: {
                    signalSelection: true
                }
            }
        });
    },
    _addAdditionalChartsToSettings: function (me) {
        // <summary>
        // This object holds all settings and options of the vcMenuTemplate
        // </summary>

        try {
            me.settings.charts = [
                { enabled: true, name: me.specific.resources.archive, id: 'archive', icon: 'fa fa-chart-column', notAllowedInterval: [], exports: ["xls", "csv", "jpg", "png", "pdf"], accumulate: true, addRampFeatures: true, price: true, co2: true, datacenter: true, singleValueAsConsumption: true, fill0: true, plausInfo: true }, 
                { enabled: true, name: me.specific.resources.rawdata, id: 'rawdata', icon: 'fa fa-database', notAllowedInterval: [3, 5], exports: ["xls", "csv", "jpg", "png", "pdf"], datacenter: true },
                { enabled: true, name: me.specific.resources.loadGear, id: 'load', icon: 'fa fa-arrow-down-short-wide', notAllowedInterval: [], exports: ["xls", "csv", "jpg", "png", "pdf"], price: true, co2: true, fill0: true },
                { enabled: true, name: me.specific.resources.zst, id: 'zst', icon: 'fa fa-meter', notAllowedInterval: [1, 5], exports: ["xls", "csv", "jpg", "png", "pdf"] },
                { enabled: true, name: me.specific.resources.minimum, id: 'min', icon: 'fa fa-arrows-down-to-line', notAllowedInterval: [1], exports: ["xls", "csv", "jpg", "png", "pdf"], addRampFeatures: true, fill0: true },
                { enabled: true, name: me.specific.resources.maximum, id: 'max', icon: 'fa fa-arrows-up-to-line', notAllowedInterval: [1], exports: ["xls", "csv", "jpg", "png", "pdf"], addRampFeatures: true, fill0: true },
                { enabled: true, name: me.specific.resources.heatmap, id: 'heatmap', icon: 'fa fa-braille', notAllowedInterval: [1], exports: ["jpg", "png", "pdf"], datacenter: true },
                { enabled: true, name: me.specific.resources.subsignal, id: 'subsignal', icon: 'fa fa-chart-pie', notAllowedInterval: [], exports: ["jpg", "png", "pdf"], price: true, co2: true },
                { enabled: true, name: me.specific.resources.dataflow, id: 'dataflow', icon: 'fa fa-share-nodes', notAllowedInterval: [], exports: [], price: true, co2: true },
                { enabled: true, name: "meter readings", id: 'meterreadings', icon: 'fa fa-share-nodes', notAllowedInterval: [], exports: ["xls"], price: true, co2: true },
                { enabled: true, name: "meter readings_adjustment", id: 'mr-adjustments', icon: 'fa fa-share-nodes', notAllowedInterval: [], exports: [] },
                { enabled: true, name: "online list", id: 'onlinelist', icon: 'fa fa-share-nodes', notAllowedInterval: [], exports: ["xls"], price: true, co2: true },


                { enabled: true, name: me.specific.resources.docu, id: 'docu', icon: 'fa fa-memo-circle-info', notAllowedInterval: [], exports: [], datacenter: true },
                { enabled: true, name: me.specific.resources.plaus, id: 'plauslist', icon: 'fa fa-arrows-to-dotted-line', notAllowedInterval: [3, 5], exports: [] },
                { enabled: true, name: me.specific.resources.configs, id: 'configs', icon: 'fa fa-cogs', notAllowedInterval: [], exports: [], datacenter: true },
                { enabled: true, name: me.specific.resources.state, id: 'status', icon: 'fa fa-traffic-light', notAllowedInterval: [3, 5], exports: [] },
                { enabled: false, name: me.specific.resources.comparison, id: 'comparisonlist', icon: 'fa fa-share-nodes', notAllowedInterval: [3, 5], exports: ["xls"] },
                { enabled: false, name: me.specific.resources.comparison, id: 'comparisonlist-simple', icon: 'fa fa-share-nodes', notAllowedInterval: [3, 5], exports: ["xls"] },
                { enabled: false, name: "DASHBOARD_TRANSLATE", id: 'dashboard', icon: 'fa fa-braille', notAllowedInterval: [], exports: [], datacenter: false },

            ];

            // add additional icon charts (directly for each signal)
            me.settings.iconCharts = [
                { enabled: true, name: me.specific.resources.dataflowDiagram, id: 'SANKEY', icon: 'fa-regular fa-share-alt', exports: [], zstOnly: false, dataflowOnly: true, alarmOnly: false },
                { enabled: true, name: me.specific.resources.subsignalDiagram, id: 'SUBSIGNAL', icon: 'fa-regular fa-chart-pie', exports: [], zstOnly: false, dataflowOnly: true, alarmOnly: false },
                { enabled: true, name: me.specific.resources.alarmPreview, id: 'ALARM', icon: 'fa-regular fa-bell', exports: [], zstOnly: false, dataflowOnly: false, alarmOnly: true },
                { enabled: true, name: me.specific.resources.zst, id: 'ZSTINFO', icon: 'fa-regular fa-tachometer-alt', exports: ["xls"], zstOnly: true, dataflowOnly: false, alarmOnly: false } // archive meter readings
            ];

        } catch (e) { me._writeErr(e); }
    },

    _setSettings: function (me) {
        // <summary>
        // This object holds all settings and options of the vcMenuTemplate
        // </summary>
        try {
            let s = me.settings.menu.top;
            let obj = me.vcMenu.menu.top;

            objArchSettings._setSingleSettings(me, s.interval, obj.interval);
            objArchSettings._setSingleSettings(me, s.datatype, obj.dataType);
            objArchSettings._setSingleSettings(me, s.charts, obj.charts);
            objArchSettings._setSingleSettings(me, s.opt, obj.opt);
            objArchSettings._setSingleSettings(me, s.export, obj.exportBtn);

            s = me.settings.menu.main;
            obj = me.vcMenu.menu.main;
            objArchSettings._setSingleSettings(me, s.button, obj.button);
            objArchSettings._setSingleSettings(me, s.date, obj.date);
            objArchSettings._setSingleSettings(me, s.dateComparison, obj.dateComparison);
            objArchSettings._setSingleSettings(me, s.rampResolution, obj.rampResolution);
            objArchSettings._setSingleSettings(me, s.rampOptions, obj.rampOptions);
            objArchSettings._setSingleSettings(me, s.rampTempCharts, obj.rampTempCharts);

            objArchSettings._setSingleSettings(me, s.specificOptions, obj.specificOptions);
            objArchSettings._setSingleSettings(me, s.history, obj.history);

            s = me.settings.selection;
            obj = me.vcMenu.selection;
            objArchSettings._setSingleSettings(me, s.choice, obj.choice.wrapper);
            objArchSettings._setSingleSettings(me, s.treemenu, obj.treeMenu.wrapper);
            objArchSettings._setSingleSettings(me, s.entries, obj.entries.wrapper);

            objArchSettings._setSingleSettings(me, s.entries.button, obj.entries.menu.button);
            objArchSettings._setSingleSettings(me, s.entries.signals, obj.entries.signals);

            //add a specific style to the entries
            me.vcMenu.selection.entries.wrapper.addClass(me.settings.selection.entries.cssClass);

            //if true we start with the content
            me.status.showContent = me.settings.toggleView;
            //... and so hide the selection for the first time ;-)

        } catch (e) { me._writeErr(e); }
    },

    _setSingleSettings: function (me, s, obj) {
        /// <summary>
        ///  sets the width class for one obj
        /// </summary>
        try {
            
            if (s.enabled) {
                if (s.cols > 0) {
                    obj.addClass("vc-grid-" + s.cols + "col");
                } else {
                    if (s.cols == 0) { obj.addClass("fix"); }
                }

            } else {
                obj.addClass("is-hidden");
            }
        } catch (e) { me._writeErr(e); }
    },


    _setInitialDates: function (me) {
        me.status.date.singleDate = window.moment(me.specific.StartDate, 'DD.MM.YYYY');
        me.status.menu.interval = me.settings.menu.top.interval.default;
        me.status.date.interval = me.settings.menu.top.interval.default;
    },

    _parseHwOptions: function (me) {
        me.data.zstTypes = JSON.parse(me.specific.zstTypes);
        me.data.hwMeter = JSON.parse(me.specific.hwMeter);
        me.data.hwMeterFormat = JSON.parse(me.specific.hwMeterFormat);
        me.data.hwMeterType = JSON.parse(me.specific.hwMeterType);
    },

    //_updateUserRightsForOpenArchive: function (me) {
    //    /// <summary>
    //    /// sets user rights and user options based on server-side settings in multiple archives mode
    //    /// </summary>
    //    try {
    //        me.settings.userRights = JSON.parse(me.specific.userRights);

    //        me.settings.menu.top.datatype.showPrice = me.settings.userRights.showPrice; // ? me.settings.menu.top.datatype.showPrice : false;
    //        me.settings.menu.top.datatype.showCo2 = me.settings.userRights.showCo2; // ? me.settings.menu.top.datatype.showCo2 : false;
    //        me.settings.menu.top.export.showFavorites = me.settings.userRights.showFavorites; // ? me.settings.menu.top.export.showFavorites : false;
    //        me.settings.menu.top.export.showShare = me.settings.userRights.showShare; // ? me.settings.menu.top.export.showShare : false;
    //        me.settings.menu.main.rampTempCharts = me.settings.userRights.isAdmin; // ? me.settings.menu.main.rampTempCharts : false;
    //        me.settings.selection.entries.signals.charts.showMeterReadings = me.settings.userRights.showMeterReadings; // ? me.settings.selection.entries.signals.charts.showMeterReadings : false;
    //        me.settings.selection.entries.signals.charts.showDataFlow = me.settings.userRights.showDataFlow; // ? me.settings.selection.entries.signals.charts.showDataFlow : false;

    //        me.settings.menu.top.datatype.showHr = me.settings.userRights.showHr; // ? me.settings.menu.top.datatype.showHr : false;
    //        me.settings.menu.top.datatype.showDataCenter = me.settings.userRights.showDataCenter; // ? me.settings.userRights.isAdmin : false;
    //        me.settings.menu.top.opt.showTickets = me.settings.userRights.showTicket; // ? me.settings.menu.top.opt.showTickets : false;            

    //        if (me.settings.menu.top.charts.enabled) {
    //            // set visibility of charts buttons rawdata and zst in the top menu depending on user rights
    //            $.each(me.settings.charts, function () {
    //                if (this.id === "rawdata" && this.enabled)
    //                    this.enabled = me.settings.userRights.showHr;
    //                else if (this.id === "zst" && this.enabled)
    //                    this.enabled = me.settings.userRights.showMeterReadings;
    //            });
    //        }

    //    } catch (e) { me._writeErr(e); }
    //},

    _setUserRights: function (me) {
        /// <summary>
        /// sets user rights and user options based on server-side settings
        /// </summary>
        try {
            me.settings.userRights = JSON.parse(me.specific.userRights);

            me.settings.menu.top.datatype.showPrice = me.settings.userRights.showPrice ? me.settings.menu.top.datatype.showPrice : false;
            me.settings.menu.top.datatype.showCo2 = me.settings.userRights.showCo2 ? me.settings.menu.top.datatype.showCo2 : false;
            me.settings.menu.top.export.showFavorites = me.settings.userRights.showFavorites ? me.settings.menu.top.export.showFavorites : false;
            me.settings.menu.top.export.showShare = me.settings.userRights.showShare ? me.settings.menu.top.export.showShare : false;
            me.settings.menu.main.rampTempCharts = me.settings.userRights.isAdmin ? me.settings.menu.main.rampTempCharts : false;
            me.settings.selection.entries.signals.charts.showMeterReadings = me.settings.userRights.showMeterReadings ? me.settings.selection.entries.signals.charts.showMeterReadings : false;
            me.settings.selection.entries.signals.charts.showDataFlow = me.settings.userRights.showDataFlow ? me.settings.selection.entries.signals.charts.showDataFlow : false;

            me.settings.menu.top.datatype.showHr = me.settings.userRights.showHr ? me.settings.menu.top.datatype.showHr : false;
            me.settings.menu.top.datatype.showDataCenter = me.settings.userRights.showDataCenter ? me.settings.userRights.isAdmin : false;
            me.settings.menu.top.opt.showTickets = me.settings.userRights.showTicket ? me.settings.menu.top.opt.showTickets : false;

            if (me.settings.menu.top.charts.enabled) {
                // set visibility of charts buttons rawdata and zst in the top menu depending on user rights
                $.each(me.settings.charts, function () {
                    if (this.id === "rawdata" && this.enabled)
                        this.enabled = me.settings.menu.top.datatype.showHr;
                    else if (this.id === "zst" && this.enabled)
                        this.enabled = me.settings.selection.entries.signals.charts.showMeterReadings;
                });
            }

        } catch (e) { me._writeErr(e); }
    },
    

    _setUserOptions: function (me) {
        /// <summary>
        /// sets user options based on server-side settings
        /// </summary>
        try {



            me.status.userOptions = JSON.parse(me.specific.userOptions);
            me.status.userOptionsSL = JSON.parse(me.specific.userOptionsSL);
            
            $.each(me.status.userOptions, function () {
                var opt = this;
                switch (opt.optid) {
                case 20:
                    me.vcMenu.menu.main.wrapper.find("#ramp-option-archive-resolution").val(opt.dval); break;
                default:
                    me.vcMenu.menu.main.wrapper.find(".ramp-icon").filter(function () { return parseInt($(this).data("optid")) == opt.optid }).toggleClass('button-toggle-active', opt.bval); break;

                }
            });

            objArchSettings._setDataTypeUserOptions(me);
            
        } catch (e) { me._writeErr(e); }
    },

    _setDataTypeUserOptions: function (me) {
        /// <summary>
        /// sets user options for the data types based on server-side settings
        /// </summary>
        try {

            // user options with optgroupid = rampmenu
            $.each(me.status.userOptions, function () {
                var opt = this;
                switch (opt.optid) {
                    case 6:
                        me.vcMenu.menu.top.dataType.find("#btn-fill0").toggleClass("button-toggle-active", opt.bval);
                        me.status.menu.fill0 = opt.bval;
                        break;
                    case 7:
                        if (me.settings.defaultChart === "archive" && (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart)) {
                            var activated = me.specific.DataCenterStart || opt.bval;
                            me.vcMenu.selection.entries.menu.dcBtn.find("#btn-activate-dc").toggleClass("button-toggle-active", activated);
                            me.status.menu.activateDataCenter = opt.bval;

                            if (me.status.menu.activateDataCenter)
                                me.status.signals.selectionLimit = 100;
                        }
                        break;
                    case 10:
                        me.vcMenu.menu.top.dataType.find("#btn-15min-consumption").toggleClass("button-toggle-active", opt.bval);
                        me.status.menu.singleValueAsConsumption = opt.bval;
                        break;
                }
            });

            // user options with optgroupid = rampsignallist
            $.each(me.status.userOptionsSL, function () {
                var opt = this;
                switch (opt.optid) {
                    case 1:
                        me.vcMenu.menu.top.dataType.find("#btn-add-temp").toggleClass("button-toggle-active", opt.bval);
                        me.status.menu.addTemp = opt.bval;
                        break;
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _saveUserOptions: function (me, obj) {
        /// <summary>
        /// sets user options based on server-side settings
        /// </summary>
        try {
            
            // user options with optgroupid = rampmenu
            var optid = obj.data('optid');
            var i;
            if (typeof optid != 'undefined') {
                var iUserOption = parseInt(obj.data('optid'));

                switch (iUserOption) {
                    case 20:
                        me.userOptions.setUserOptions({ 'optgroupid': 'rampmenu', 'optid': iUserOption, 'dval': parseInt(obj.val()) }, function () { });
                        if (me.status.userOptions != null) {
                            i = me.status.userOptions.filter(function (item) { return item.optid == iUserOption })[0];
                            if (i != undefined) { i.dval = parseInt(obj.val()); }
                        }
                        break;


                    default:
                        obj.toggleClass("button-toggle-active");
                        me.userOptions.setUserOptions({ 'optgroupid': 'rampmenu', 'optid': iUserOption, 'bval': obj.hasClass("button-toggle-active") }, function () { });
                        if (me.status.userOptions != null) {
                            i = me.status.userOptions.filter(function (item) { return item.optid == iUserOption })[0];
                            if (i != undefined) { i.bval = obj.hasClass("button-toggle-active"); }
                        }
                        break;
                }
            }

            // user options with optgroupid = rampsignallist
            var dataoptid = obj.data('data-optid');
            if (typeof dataoptid != 'undefined') {
                var dUserOption = parseInt(obj.data('data-optid'));
                switch (dUserOption) {
                    case 1:
                        obj.toggleClass("button-toggle-active");
                        me.userOptionsSL.setUserOptions({ 'optgroupid': 'rampsignallist', 'optid': dUserOption, 'bval': obj.hasClass("button-toggle-active") }, function () { });
                        if (me.status.userOptions != null) {
                            i = me.status.userOptionsSL.filter(function (item) { return item.optid == dUserOption })[0];
                            if (i != undefined) { i.bval = obj.hasClass("button-toggle-active"); }
                        }
                        break;
                }
            }

            me._trigger("MenuChanged", true);
        } catch (e) { me._writeErr(e); }
    }
};